<ngb-timepicker [(ngModel)]="time" 
    [hourStep]="hourStep" [minuteStep]="minuteStep" (click)="clickHour()" (window:keypress)="keyHour()" (ngOnModleChange)="onChangeEvent($event)" ></ngb-timepicker>